/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Auto format event text" |
*
* @param {Context_Menu_Auto_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format_label = /** @type {((inputs?: Context_Menu_Auto_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre en forme automatiquement le texte des événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung des Ereignistextes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica del testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование текста события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatear automáticamente el texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストの自動フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट को स्वचालित रूप से फ़ॉर्मेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática do texto do evento")
	return /** @type {LocalizedString} */ ("Auto format event text")
});